import { makeStyles } from 'tss-react/mui';


// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles({ name: 'MainLayoutSideBar' })((theme) => ({
  sidebar: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    zIndex: -123,
  },
  wrapper: {
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'column',
  },
  tools: {
    paddingBottom: 0,
    marginBottom: '-25px',
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: '12px',
    lineHeight: 1,
    letterSpacing: '1px',
    '& svg': {
      marginBottom: '2px',
    },
  },
  activeNav: {
    color: theme.palette.darkSlate.main,
    '& svg': {
      fill: theme.palette.darkSlate.main,
    },
    '& div span': {
      display: 'inline-block',
      borderBottom: '2px solid #57807D',
      marginBottom: '-2px',
      color: theme.palette.darkSlate.main,
    },
  },
  list: {
    '& a': {
      paddingLeft: '24px',
    },
  },
  secondList: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    '& a:last-child': {
      marginTop: 'auto',
      display: 'flex',
      justifyContent: 'center',
      '& span': {
        fontSize: '14px',
        marginTop: '3px',
      },
      '& .MuiListItemIcon-root': {
        minWidth: '20px',
        '& svg': {
          width: '14.25px',
        },
      },
    },
  },
  listItem: {
    paddingLeft: '24px',
  },
  privacy: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    paddingLeft: '20px',
    '& a': {
      fontSize: '14px',
      lineHeight: '157%',
      letterSpacing: '0.1px',
      textDecoration: 'none',
      margin: '0px 6px 30px 4px',
      color: '#0000008A',
    },
  },
  dot: {
    margin: 0,
    marginTop: 1,
    color: '#C7C09C',
  },
  contactSupportContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px',
  },
  contactSupportLink: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  contactSupportText: {
    color: '#0000008A',
    fontSize: '14px',
    letterSpacing: '0.1px',
    paddingTop: '3px',
  },
  contactSupportIcon: {
    color: '#0000008A',
    fontSize: '18px',
    marginRight: '5px',
  },
}));
